// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { getProp } from "@insite/mobius/utilities";
import { qtyFieldStyles } from "@pace/App/Components/Qty/QtyField";
import cartLineSharedStyles from "@pace/App/SharedStyles/CartLineSharedStyles";
import { FormFieldLabel } from "@pace/MobiusOverrides/FormField";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { color } from "@pace/XDL/Utilities";
import { css } from "styled-components";

qtyFieldStyles.actionButton = {
    css: css`
        height: 31px;
        padding: 12px 8px;
        display: flex;
        align-items: center;
        transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
        border: none;
        background-color: ${color("common.ui2")};
        ${IconWrapper} {
            color: ${color("common.ui14")};
        }
        &:hover:not(:disabled) {
            background: ${color("common.ui9")};
            ${IconWrapper} {
                color: ${color("common.ui1")};
            }
        }
        &:focus {
            background: ${color("common.ui8")};
            ${IconWrapper} {
                color: ${color("common.ui1")};
            }
        }
    `,
};

qtyFieldStyles.wrapper = {
    css: css`
        background: ${color("common.ui1")};
        display: flex;
        align-items: center;
        min-width: 92px;
        width: 92px;
        border-radius: 4px;
        overflow: hidden;
        &:not(${FormFieldLabel}) {
            border: 1px solid ${color("common.ui12")};

            &:hover {
                border-color: ${color("common.ui8")};
            }

            &:focus-within {
                border-color: ${color("primary")};
            }
        }
        overflow-x: hidden;
    `,
};

qtyFieldStyles.editableQuantityTextField = {
    sizeVariant: "small",
    mergeCss: true,
    cssOverrides: {
        formField: css`
            ${TypographyStyle} {
                text-align: center;
            }

            &&& {
                input {
                    &,
                    &:hover:not(:disabled),
                    &:focus:not(:disabled) {
                        border: none;
                        border-radius: 0;
                        outline: none;
                        box-shadow: none;
                        padding: 0 2px;
                    }
                }
            }
        `,
        formInputWrapper: css`
            &,
            &:hover:not(:disabled),
            &:focus:not(:disabled) {
                border: none;
                box-shadow: none;
                padding: 0;
            }
        `,
        inputSelect: css`
            font-size: 14px;
            line-height: 16px;
            text-align: center;
            height: 29px;
        `,
    },
};

qtyFieldStyles.container = {
    css: css`
        display: flex;
        gap: 5px;
        align-items: center;
        flex-wrap: wrap;
        max-width: 114px;
    `,
};

qtyFieldStyles.questionIconStyles = {
    size: 14,
    css: css`
        &,
        & > svg {
            opacity: 0.44;
            color: ${color("secondary")};
            &:hover {
                opacity: 1;
            }
        }
    `,
};

qtyFieldStyles.multipleSaleQtyToolTip = {
    cssOverrides: {
        tooltipClickable: css`
            margin: 0;
        `,
    },
};

qtyFieldStyles.qtyLabelNotEditable = {
    ...cartLineSharedStyles.qtyLabel,
};

qtyFieldStyles.valueText = {
    weight: fontConfig.weight.bold,
};

qtyFieldStyles.qtyLabel = {
    size: 12,
    lineHeight: "13px",
    weight: fontConfig.weight.regular,
};

qtyFieldStyles.qtyErrorMessage = {
    size: 14,
    lineHeight: "22px",
    css: css`
        flex: 0 0 110px;
    `,
};
